import Modal from "components/layout/modal";
import { Locale, LocaleString } from "models/locale";
import { FunctionComponent, useState } from "react";
import UsersForm from "./add-user-modal-form-users";
import { useLocale } from "stores/hooks/locale";
import InvitesForm from "./add-user-modal-form-invites";
import Sending from "./add-user-model-sending";
import { List } from "models/list";

interface AddUserModalProps {
  list: List;
  onSubmit: () => Promise<void>;
  onClose: () => Promise<void>;
}

export interface User {
  email: string;
  locale: Locale;
}

const AddUserModal: FunctionComponent<AddUserModalProps> = ({
  list,
  onSubmit,
  onClose,
}) => {
  const locale = useLocale();
  const [stage, toggleStage] = useState<"users" | "invites" | "sending">(
    "users",
  );
  const [users, toggleUsers] = useState<User[]>([{ email: "", locale }]);
  const [send_email, toggleSendEmail] = useState(false);
  const [subject, toggleSubject] = useState<LocaleString | undefined>(
    undefined,
  );
  const [message, toggleMessage] = useState<LocaleString | undefined>(
    undefined,
  );

  let title = "";
  if (stage === "users") {
    title = "Lisää ilmoitusvelvollisia";
  } else if (stage === "invites") {
    title = "Lähetä sähköpostikutsut";
  }

  return (
    <Modal wide title={title}>
      {stage === "users" && (
        <UsersForm
          defaults={users}
          onPrevious={async () => onClose()}
          onNext={async (users, send_email) => {
            toggleStage(send_email ? "invites" : "sending");
            toggleSendEmail(send_email);
            toggleUsers(users);
          }}
        />
      )}
      {stage === "invites" && (
        <InvitesForm
          onPrevious={async () => {
            toggleStage("users");
          }}
          onNext={async (subject, message) => {
            toggleSubject(subject);
            toggleMessage(message);
            toggleStage("sending");
          }}
        />
      )}
      {stage === "sending" && (
        <Sending
          list={list}
          users={users}
          invite={send_email}
          subject={subject}
          message={message}
          onFinish={async () => {
            onSubmit();
            onClose();
          }}
        />
      )}
    </Modal>
  );
};

export default AddUserModal;
